import { type OrderWithReturnableItems } from "@redotech/redo-order-core-common/order";

export const isDevEnvironment = () => process.env.NODE_ENV === "development";

export function hasUnfulfilledItems(order: OrderWithReturnableItems): boolean {
  const lineItems = order.shopify?.line_items ?? [];
  return lineItems.some(
    (lineItem) =>
      (lineItem.current_quantity ?? lineItem.quantity) > 0 &&
      lineItem.fulfillment_status !== "fulfilled",
  );
}
